import React, { ReactElement, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import {
  Icon,
  TopPaymentInsideNotificationContainer,
  TopPaymentNotificationContainer,
} from './TopPaymentNotificationMobile.styles';
import withSelectedMethodContext from '../../hoc/withSelectedMethodContext';
import { ISelectedMethodContext } from '../../types/SelectedMethodContext';
import {
  disabledPaymentMethodNotification,
  NotificationProperties,
  unsupportedApplePayPaymentMethodNotification,
} from '../paymentNotification/NotificationProperties';
import { DisableReason, PaymentCategoryType } from '../../consts';
import { IPayment } from '../../types/Payment';
import withContext from '../../hoc/withContext';
import ExpandableContent from '../card/wl/savedInstruments/expandableContent/ExpandableContent';
import { AnimationType } from '../card/wl/savedInstruments/expandableContent/ExpandableContent.types';

function isNotificationVisibleForCurrentProgress(chosenNotification: NotificationProperties, currentProgress: number) {
  return currentProgress >= chosenNotification.fromProgress && currentProgress <= chosenNotification.toProgress;
}

function isUnsupportedApplePay(payment: Partial<IPayment>, selectedPaymentMethodDisabledReason: string) {
  return (
    PaymentCategoryType.APPLE_PAY === payment.selectedPaymentMethodType &&
    DisableReason.UNSUPPORTED === selectedPaymentMethodDisabledReason
  );
}

function getChosenNotification({
  payment,
  selectedPaymentMethodDisabledReason,
}: {
  payment: Partial<IPayment>;
  selectedPaymentMethodDisabledReason: string;
}) {
  return isUnsupportedApplePay(payment, selectedPaymentMethodDisabledReason)
    ? unsupportedApplePayPaymentMethodNotification
    : disabledPaymentMethodNotification;
}

function TopPaymentNotification(
  props: RouteComponentProps &
    Partial<IContext> &
    Partial<ISelectedMethodContext> & {
      payment: Partial<IPayment>;
    }
): ReactElement {
  const {
    isSelectedPaymentMethodDisabled,
    progress,
    selectedPaymentMethodDisabledReason,
    payment,
    paymentMethodType,
  } = props;
  const [notificationProperties, setNotificationProperties] = useState<NotificationProperties>();
  const [notificationVisible, setNotificationVisible] = useState<boolean>(false);

  useEffect(() => {
    const currentProgress = progress || 0;

    const shouldDisplayDisabledPaymentMethodNotification =
      isSelectedPaymentMethodDisabled === true && !paymentMethodType;

    let isNotificationVisible = false;

    if (shouldDisplayDisabledPaymentMethodNotification) {
      const chosenNotification: NotificationProperties = getChosenNotification({
        payment,
        selectedPaymentMethodDisabledReason,
      });
      setNotificationProperties(chosenNotification);
      isNotificationVisible = isNotificationVisibleForCurrentProgress(chosenNotification, currentProgress);
    }
    setNotificationVisible(isNotificationVisible);
  }, [progress, paymentMethodType, payment, selectedPaymentMethodDisabledReason, isSelectedPaymentMethodDisabled]);
  return (
    <>
      {notificationProperties && (
        <TopPaymentNotificationContainer
          isVisible={notificationVisible}
          className="top-payment-notification__container"
        >
          <ExpandableContent expanded={notificationVisible} type={AnimationType.OpacityAndHeight}>
            <TopPaymentInsideNotificationContainer>
              <Icon />
              <p>
                {notificationProperties.notification && <FormattedMessage id={notificationProperties.notification} />}{' '}
                {notificationProperties.notificationBold && (
                  <FormattedMessage id={notificationProperties.notificationBold} />
                )}
              </p>
            </TopPaymentInsideNotificationContainer>
          </ExpandableContent>
        </TopPaymentNotificationContainer>
      )}
    </>
  );
}

export default withContext(withSelectedMethodContext(withRouter(TopPaymentNotification)));
